import React from 'react';

export const AccordionContext = React.createContext<IAccordionContext>({
  expanded: false,
  disabled: false,
  id: '',
  toggle: () => {},
});

interface IAccordionContext {
  expanded: boolean;
  disabled: boolean;
  id: string;
  toggle: (event?: React.MouseEvent<HTMLElement>) => void;
}
